import { DateTime } from "@/Common/Helpers/DateTime";

/**
 * Represents information about an external patient subscription.
 *
 * @remarks
 * This class contains details such as the icon, descriptions, origin date, and external subscription ID
 * for a patient's subscription originating from an external source.
 * @constructor
 * Creates a new instance of ExternalPatientSubscriptionInfo.
 * @param {Partial<ExternalPatientSubscriptionInfo>} [init] - Optional initialization object.
 */
class ExternalPatientSubscriptionInfo {
    public Icon: ExternalPatientSubscriptionInfoIcon;
    public ShortDescription: string;
    public Description: string;
    public ExternalSubscriptionOrigin: DateTime;
    public ExternalSubscriptionId: string;

    public constructor(init?: Partial<ExternalPatientSubscriptionInfo>) {
        Object.assign(this, init);
    }
}
/**
 * Represents the available icon types for displaying external patient subscription information.
 *
 * @remarks
 * Used to visually indicate the subscription status of a patient in the UI.
 */
enum ExternalPatientSubscriptionInfoIcon {
    NotRegisteredMark,
    GreenCheckMark,
    RedX
}

export { ExternalPatientSubscriptionInfo, ExternalPatientSubscriptionInfoIcon };
